<div class="row m-0">
  <div class="col-12 page-heading-wrapper">
    <gb-ui-page-heading
      [titleText]="this.selectedDepartment?.extra?.location_page_title"
      [displayBacklink]="true"
      [backLinkText]="'COMMON.BACK' | translate"
      (back)="routerGoBack()"
    ></gb-ui-page-heading>
  </div>
</div>

<div class="govuk-width-container">
  <div class="govuk-grid-row">
    <div class="govuk-grid-column-full">
      <h1 id="main-content" tabindex="-1">{{datastoreService.pageContent.location_page_subtitle}}</h1>
       <p class="body-xl">
        {{ datastoreService?.pageContent?.location_page_subtitle_body }}
      </p>
      <hr />
    </div>
  </div>

  <div class="govuk-grid-row">
    <div
      class="govuk-grid-column-full"
      *ngIf="config?.location_layout === 'list'"
    >
      <div *ngFor="let location of locations">
        <div class="place group place-list__item">
          <div class="information">
            <div class="address vcard">
              <div class="adr org fn">
                <div class="adr govuk-body">
                  <h2
                    class="fn govuk-!-margin-bottom-0 govuk-heading-s govuk-!-display-inline"
                  >
                    {{ location.name }}
                  </h2>

                  <br /><span class="street-address">
                    {{
                      location?.addresses?.address1 ||
                        location?.address?.address1 ||
                        'Address 1 missing'
                    }},
                    {{
                      location?.addresses?.address2 ||
                        location?.address?.address2 ||
                        'Address 2 missing'
                    }} </span
                  ><span class="govuk-visually-hidden">,</span>

                  <br /><span class="locality">
                    {{
                      location?.addresses?.address3 ||
                        location?.address?.address3 ||
                        'Address 3 missing'
                    }}</span
                  >
                  <span class="govuk-visually-hidden">,</span>

                  <br /><span class="postal-code">
                    {{
                      location?.addresses?.postcode ||
                        location?.address?.postcode ||
                        'Postcode missing'
                    }}</span
                  >
                </div>

                <ul class="govuk-list view-maps">
                  <li>
                    <a
                      class="govuk-link"
                      target="_blank"
                      href="{{ location?.addresses?.map_url }}"
                      data-ga4-index='{"index_link": 1}'
                      >View on Google Maps</a
                    >
                  </li>
                </ul>

                <div>
                  <button
                    type="button"
                    class="govuk-button govuk-button--inverse"
                    data-module="govuk-button"
                    role="button"
                    (click)="selectLocation(location)"
                    tabindex="0"
                    attr.aria-label="Select {{ location.name }}"
                  >
                    {{ 'COMMON.BTN_SELECT' | translate }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <br />
      </div>
    </div>

    <div class="govuk-grid-column-full">
      <div class="govuk-grid-row locations-grid" *ngIf="config?.location_layout === 'grid'">
        <div class="govuk-grid-column-one-third" *ngFor="let location of locations">
            <div class="place group place-list__item">
              <div class="information">
                <div class="address vcard">
                  <div class="adr org fn">
                    <div class="adr govuk-body">
                      <h2
                        class="fn govuk-!-margin-bottom-0 govuk-heading-s govuk-!-display-inline"
                      >
                        {{ location.name }}
                      </h2>

                      <br /><span class="street-address">
                        <ng-container
                          *ngIf="
                            location?.addresses?.address1 ||
                            location?.address?.address1
                          "
                        >
                          {{
                            location?.addresses?.address1 ||
                              location?.address?.address1
                          }},
                        </ng-container>
                        <br />
                        <ng-container
                          *ngIf="
                            location?.addresses?.address2 ||
                            location?.address?.address2
                          "
                        >
                          {{
                            location?.addresses?.address2 ||
                              location?.address?.address2
                          }},
                        </ng-container> </span
                      ><span class="govuk-visually-hidden">,</span>

                      <ng-container
                        *ngIf="
                          location?.addresses?.address3 ||
                          location?.address?.address3
                        "
                      >
                        <span class="locality">
                          <br />
                          {{
                            location?.addresses?.address3 ||
                              location?.address?.address3
                          }},</span
                        >
                      </ng-container>
                      <span class="govuk-visually-hidden">,</span>

                      <ng-container
                        *ngIf="
                          location?.addresses?.address4 ||
                          location?.address?.address4
                        "
                      >
                        <br />
                        <span class="locality">
                          {{
                            location?.addresses?.address4 ||
                              location?.address?.address4
                          }},</span
                        >
                      </ng-container>
                      <span class="govuk-visually-hidden">,</span>

                      <ng-container
                        *ngIf="
                          location?.addresses?.address5 ||
                          location?.address?.address5
                        "
                      >
                        <br />
                        <span class="locality">
                          {{
                            location?.addresses?.address5 ||
                              location?.address?.address5
                          }},</span
                        >
                      </ng-container>
                      <span class="govuk-visually-hidden">,</span>

                      <ng-container
                        *ngIf="
                          location?.addresses?.postcode ||
                          location?.address?.postcode
                        "
                      >
                        <br />
                        <span class="postal-code">
                          {{
                            location?.addresses?.postcode ||
                              location?.address?.postcode
                          }}</span
                        >
                      </ng-container>
                    </div>

                    <!--  <ul class="govuk-list view-maps">
                                          <li><a class="govuk-link" target="_blank"
                                                  href="{{location?.addresses?.map_url}}"
                                                  data-ga4-index="{&quot;index_link&quot;: 1}">View on Google Maps</a>
                                          </li>
                                      </ul> -->

                    <div>
                      <button
                        type="button"
                        class="govuk-button govuk-button--inverse"
                        data-module="govuk-button"
                        role="button"
                        (click)="selectLocation(location)"
                        tabindex="0"
                        attr.aria-label="Select {{ location.name }}"
                      >
                        {{ 'COMMON.BTN_SELECT' | translate }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </div>
      </div>
    </div>

  </div>
</div>
